























































































































/* import { Component,Model, Vue } from "vue-property-decorator"; */
import { Component, Vue } from "vue-property-decorator";
import { BPopover } from "bootstrap-vue";
import DatePicker from "vuejs-datepicker";
import { GapMemberFilter } from "@/store/modules/types";

@Component({
  components: {
    BPopover,
    DatePicker,
  },
})
export default class PatientFilter extends Vue {
 /* @Model("change") readonly filter!: GapStatusSummaryReportFilter; */
  id = "patient-filter-popover";
  target = "patient-filter-target";
  filter = this.defaultFilter();
  insurers = Array<any>();
  ipas = Array<any>();
  insurersSelected =[];
  showInsurerSelect = false;
  showIPASelect = false;
  defaultFilter(): GapMemberFilter {
    return {
      id: "",
      firstName: "",
      lastName: "",
      insurerMemberId: "",
      EMR_ID: "",
      birthdateFrom: null,
      birthdateTo: null,
      gender: ""
    };
  }
  search() {
   
    /*
    const filter = { ...this.filter };
    this.$store.commit("gaps/SET_PATIENT_FILTER", filter);
    */
   this.$store.state.gaps.filter.report.member =  this.filter;
   this.$emit('refresh');
    this.close();
  }
  clear() {
    this.filter = this.defaultFilter();
    //this.$store.commit("gaps/SET_PATIENT_FILTER", this.filter);
    
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  get checkedInsurers(): Array<any> {
    return this.insurers
      .filter((i) => {
        return i.checked;
      })
      .map((i) => i.id);
  }

  get checkedIPAs(): Array<any> {
    return this.ipas
      .filter((i) => {
        return i.checked;
      })
      .map((i) => i.name);
  }
  mounted() {
    const { member } = this.$store.state.gaps.filter.report;
    this.filter = JSON.parse(JSON.stringify(member));
    /*
    this.insurers = JSON.parse(JSON.stringify(this.$store.state.gaps.insurers)).map((i) => {
      i.checked = patient.insurerList.includes(i.id);
      return i;
    });

    this.ipas = JSON.parse(JSON.stringify(this.$store.state.gaps.ipas)).map((i) => {
      i.checked = patient.ipaList.includes(i.name);
      return i;
    });
    */

  }
}
